class SiteElementSticky
    extends QueryElement<HTMLElement> {

    private _style: CSSStyleDeclaration;
    private _height: number;
    private _lastScrollTop: number;
    private _startY: number;
    private _currentTop: number;
    private _setStartY: boolean;
    
    constructor(element: HTMLElement) {
        super(element);

        var style = this.style();
        if (style == null)
            throw "Unable to get style!";
        var parent = this.parent();
        if (parent == null)
            throw "Unable to get parent!";

        this._style = style;
        this._height = 0;
        this._startY = parseInt(style.top);
        this._currentTop = 0;
        this._lastScrollTop = 0;

        this._setStartY = style.top == "";

        window.addEventListener("scroll", () => this.scroll());
        window.addEventListener("resize", () => this.resize());

        this.resize();
        this.scroll();
    }

    scroll() {
        let top = document.documentElement.scrollTop;
        let position = this.position();
        if (position == null)
            throw "Unable to get position!";
        
        var changeY = top - this._lastScrollTop;

        let height = position.height;
        let minTop = this._startY;

        let maxTop = (height - (this._height)) * -1;
        
        if (maxTop > minTop)
            maxTop = minTop;
        
        let newTop = this._currentTop;
        if (changeY > 0) {
            newTop -= changeY;

            if (newTop < maxTop)
                newTop = maxTop;
        } else {
            newTop -= changeY;
            if (newTop > minTop)
                newTop = minTop;
        }
        
        if (newTop != this._currentTop)
            this._style.top = newTop + "px";

        this._lastScrollTop = top;
        this._currentTop = newTop;
    }
    resize() {
        var position = this.position();
        if (position == null)
            throw "Unable to get position!";
        
        if (this._setStartY)
            this._startY = position.y;
        this._height = document.documentElement.clientHeight;
    }
}